import {
    RecoverUsernamePasswordModel,
    RecoverUsernamePasswordParamater,
    getUsernamePasswordInfo,
} from "@NA/Services/ADIRecoverUsernamePassword";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    RecoverUsernamePasswordParamater & HasOnSuccess & HasOnError,
    RecoverUsernamePasswordModel
>;

export const setRecoverUsernamePassword: HandlerType = async (props: any) => {
    props.apiResult = await getUsernamePasswordInfo({
        userEmail: props.parameter.userEmail,
        passwordEmail: props.parameter.passwordEmail,
        isPasswordReset: props.parameter.isPasswordReset,
        isuserNameReset: props.parameter.isuserNameReset,
        userNotFound: props.parameter.userNotFound,
        isSuccess: props.parameter.isSuccess,
        uri: props.parameter.uri,
        properties: props.parameter.properties,
    });
};

export const DispatchCompleteRecoverUsernamePassword: HandlerType = props => {
    if (props.apiResult) {
        props.parameter?.onSuccess?.(props.apiResult as any);
    } else {
        props.parameter?.onError?.(props.apiResult);
    }
};

export const chain = [setRecoverUsernamePassword, DispatchCompleteRecoverUsernamePassword];

const recoverUsernamePassword = createHandlerChainRunner(chain, "RecoverUsernamePassword");
export default recoverUsernamePassword;
